export type SignerInfo = {
  identifier?: string;
  name?: string;
  email?: string;
  phone?: string;
  country?: string;
  profession?: string;
  maritalStatus?: string;
};

export type Aval = {
  type?: AvalType;
  signer?: SignerInfo;
  business?: { name: string; identifier: string };
  spouseRelation?: { name: string; identifier: string };
};

export const AvalTypeOptions = [
  { value: 'SAME_COMPANY', label: 'Misma empresa' },
  { value: 'OTHER_COMPANY', label: 'Otra empresa' },
  { value: 'SPOUSE', label: 'Cónyuge' },
];

export type AvalType = (typeof AvalTypeOptions)[number]['value'];
